import { Component, OnInit, Input } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup } from '@angular/forms';
@Component({
  selector: 'app-referredarray',
  templateUrl: './referredarray.component.html',
  styleUrls: ['./referredarray.component.css']
})
export class ReferredarrayComponent implements OnInit {
  public isCollapsed = true;
  @Input()
  public referredFormArray: FormArray;
  static buildReferred() {
    return new FormArray([
      this.buildRefer(''),
    ]);
  }

  static buildRefer(val: string): any {
    return new FormGroup({
      refer: new FormControl(val)
    });
  }
  constructor() { }

  ngOnInit() {
  }
  addRefer() {
    this.referredFormArray.push(ReferredarrayComponent.buildRefer(''));
    this.isCollapsed = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/form-control/referred-form-control/referredarray.component.ts